import { jsx as o } from "react/jsx-runtime";
import { RocheUIIcon as i } from "../icon/roche-icon.js";
import n from "./roche-loading-icon.module.scss.js";
const c = "loading", e = "24px", I = () => /* @__PURE__ */ o("div", { className: n["loading-icon"], children: /* @__PURE__ */ o(i, { icon: c, height: e, decorative: !0, display: "inline" }) });
export {
  I as RocheUILoadingIcon
};
